export default __webpack_public_path__ + "static/media/photo--lg--96.464bb669.jpg";